const fallback = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
});
const uuid = (_crypto = globalThis.crypto) => {
    if (typeof _crypto === 'undefined') {
        return fallback();
    }
    if (_crypto.randomUUID) {
        return _crypto.randomUUID();
    }
    if (!_crypto.getRandomValues) {
        return fallback();
    }
    // generate uuid v4
    const bytes = new Uint8Array(16);
    _crypto.getRandomValues(bytes);
    // Set the version to 4 (UUIDv4)
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    // Set the variant to RFC 4122 (variant 1)
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    // Convert to a UUID string
    let uuid = '';
    for (let i = 0; i < 16; i += 1) {
        const hex = bytes[i].toString(16).padStart(2, '0');
        uuid += hex;
        if (i === 3 || i === 5 || i === 7 || i === 9) {
            uuid += '-';
        }
    }
    // Ensure that the UUID is lowercase and resolve some memory leaks.
    // SEE: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return uuid.toLowerCase();
};
export default uuid;
